import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export interface TaxonomyOption {
  name: string; // The name of the taxonomy option
  fullName: string; // The full name of the taxonomy option, including parent taxonomies
  id: string; // The id that represents this taxonomy option
}

export const TaxonomyServiceInterfaceToken: InjectionToken<TaxonomyServiceInterface> =
  new InjectionToken<TaxonomyServiceInterface>('TaxonomyServiceInterface');

export interface TaxonomyServiceInterface {
  getTaxonomyIds(): Observable<TaxonomyOption[]>;
}
